import { createMemo, For } from "solid-js";
import type { JSX } from "solid-js";
import type { Task } from "../../../types/Task";
import { getTaskRecipients, getTaskRecipientStatus } from "../../../utils/taskUtil";
import { ViewTaskUserModal } from "./ViewTaskModal";
import { useTranslation } from "../../../state/i18n";
import { useModalManager } from "../../../components/modal/ModalManager";
import ButtonLink from "../../../components/link/ButtonLink";
import Pill from "../../../components/pill/Pill";

type TaskRecipientsCellContentProps = {
  task: Task;
};

const TaskRecipientsCellContent = (props: TaskRecipientsCellContentProps): JSX.Element => {
  const { t } = useTranslation();
  const { open } = useModalManager();
  const recipients = createMemo(() => getTaskRecipients(props.task));

  return (
    <ul>
      <For each={recipients()}>
        {(recipient) => {
          const status = getTaskRecipientStatus(recipient, props.task.status);

          return (
            <li class="flex">
              <ButtonLink
                label={recipient.user.username}
                classList={{ grow: true }}
                onClick={() =>
                  open({
                    content: () => (
                      <ViewTaskUserModal
                        username={recipient.user.username}
                        fulfilment={recipient.fulfilment}
                        status={status}
                      />
                    ),
                  })
                }
              />
              <span>
                <Pill label={t(status.label)} variant={status.variant} />
              </span>
            </li>
          );
        }}
      </For>
    </ul>
  );
};

export default TaskRecipientsCellContent;
